import { DBFactory } from "~/classes/database/db_factory";
import { BaseModel } from "../base.model";

type UserPermissionConstructorParams = {
  id: string;
  description: string;
  parentPermission?: string;
  displayOrder: number;
};

export type UserPermissions = UserPermission[];
export class UserPermission extends BaseModel {
  id: string;
  description: string;
  parentPermission?: string;
  displayOrder: number;

  constructor({
    id,
    description,
    parentPermission,
    displayOrder,
  }: UserPermissionConstructorParams) {
    super();
    this.id = id;
    this.description = description;
    this.parentPermission = parentPermission;
    this.displayOrder = displayOrder;
  }

  override get databaseConfig() {
    return {
      collection: "/userPermissions",
      path: `userPermissions/${this.id}`,
    };
  }

  static override fromMap(map: any): UserPermission {
    return new UserPermission(map);
  }

  async save(options?: { childPermissions?: UserPermissions }) {
    const db = DBFactory.createDatabase();

    const childPermissions = options?.childPermissions ?? [];

    db.batchUpdate([this, ...childPermissions]);
  }

  async delete() {
    const db = DBFactory.createDatabase();
    db.delete(this.databaseConfig);
  }
}
